import styled from 'styled-components'
import active from './active.png'

export default styled.button`
  padding: 20px 27px;
  border: none;
  color: white;
  font-size: 20px;
  line-height: 20px;
  font-family: 'chaparral-pro', serif;
  background: url(${() => active}) 0 center no-repeat;
  filter: ${props =>
    props.disabled || props.visuallyDisabled ? 'grayscale(100%)' : 'none'};
`



// WEBPACK FOOTER //
// ./components/atoms/button/index.js